import css from './mdm.module.css'
import NavigationBreadcrumbs from 'src/navigation/components/NavigationBreadcrumbs'
import MainLayout from '@/shared/Layouts/MainLayout'
import Tabs from '@/shared/Tabs'
import mdmTabs, { TMDMTab } from '@/pages/MDM/mdm.tabs.ts'
import { useState } from 'react'
import PrimitivesTabContent from 'src/pages/MDM/TabsContent/EnumsTabContent'
import UnitsTabContent from '@/pages/MDM/TabsContent/UnitsTabContent'
import PassportsTabContent from '@/pages/MDM/TabsContent/PassportsTabContent'
import useTitle from '@/shared/hooks/useTitle'

const MDMPage = () => {
  useTitle('MDM')
  const [tab, setTab] = useState<TMDMTab>('primitives')

  const renderContent = () => {
    switch (tab) {
      case 'primitives':
        return <PrimitivesTabContent />
      case 'aggregates':
        return <UnitsTabContent />
      case 'passports':
        return <PassportsTabContent />
    }
  }

  return (
    <MainLayout>
      <div className={css.wrapper}>
        <div className="flex-lines gap16 height100">
          <NavigationBreadcrumbs />
          <div className="flex-lines gap4">
            <h2 className="text-heading-3">Master Data Management</h2>
          </div>
          <div className={css.mainCard}>
            <Tabs tabs={mdmTabs} onSelect={setTab as any} selectedTab={tab} />
            {renderContent()}
          </div>
        </div>
      </div>
    </MainLayout>
  )
}

export default MDMPage
